import React, {useEffect, useState} from "react"
import {createPortal} from "react-dom"
import {connect} from "react-redux"

import _ from "lodash"

import InputMask from "react-input-mask";

import {httpClient} from "funcs"
import Popup from "../../components/Popup";
import TextField from "../../components/elements/TextField";
import PhoneNumberInput from "../../components/PhoneNumberInput";
import "pages/Styles/UIKit_v2.sass";
import notifyUser, {notifyAboutError} from "../../methods/notifyUser";
import {ReactComponent as Edit} from "../Icons/size24/Edit.svg"
import cleanPhoneNumber from "../../methods/cleanPhoneNumber";

import {BANK_DETAIL_FIELDS} from "./BankDetailsView";
import UserStamp, {ENTREPRENEUR_STAMP_KEY} from "./UserStamp"
import UserSignature, {CLIENT_SIGNATURE_KEY} from "./UserSignature"
import moment from "moment";
import {validate} from "../../validate";
import VerificationCodeView from "../Auth/VerificationCodeView";
import {sendVerificationCode} from "../../methods/sendVerificationCode";
import {cleanDigitsField} from "../../methods/cleanDigitsField";
import TextArea from "../../components/elements/TextArea";
import {UI_LAYER_POPUP} from "../../constants/uiLayers";
import {
  hasOgrnField,
  hasRussianPassportFields,
  normalizeJurisdictionCode,
  passportNumberReactInputMask,
  taxIdLabel,
  taxIdReactInputMask,
} from "../../methods/jurisdictionIdentifiers";

const MAIN_FIELDS = [
  {
    key: "email",
    label: "E-Mail",
    mask: "",
  },
  {
    key: "phone_number",
    label: "Телефон для входа"
  },
  {
    key: "additional_phone_number",
    label: "Телефон для клиентов",
  }
]

const CUSTOMER_FIELDS = (jurisdiction: string) => {
  const fields: Array<{key: string, label: string, mask: string}> = [
    {
      key: "last_name",
      label: "Фамилия",
      mask: "",
    },
    {
      key: "first_name",
      label: "Имя",
      mask: "",
    },
    {
      key: "middle_name",
      label: "Отчество",
      mask: "",
    },
    {
      key: "birth_date",
      label: "Дата рождения",
      mask: "99.99.9999",
    },
    {
      key: "law_address",
      label: "Адрес регистрации",
      mask: "",
    },
    {
      key: "tax_id",
      label: taxIdLabel(jurisdiction, "customer"),
      mask: taxIdReactInputMask(jurisdiction),
    },
    {
      key: "passport.number",
      label: "Серия и номер",
      mask: passportNumberReactInputMask(jurisdiction),
    },
  ]

  if (hasRussianPassportFields(jurisdiction)) {
    fields.push({
      key: "passport.issued_by_code",
      label: "Код подразделения",
      mask: "999-999",
    })
  }

  fields.push(
    {
      key: "passport.issued_by",
      label: "Кем выдан паспорт",
      mask: "",
    },
    {
      key: "passport.issued_at",
      label: "Дата выдачи паспорта",
      mask: "99.99.9999",
    },
    {
      key: "passport.registration",
      label: "Адрес регистрации",
      mask: "",
    },
  )

  return fields
}

const ENTREPRENEUR_FIELDS = (jurisdiction: string) => {
  const fields: Array<{key: string, label: string, mask: string}> = [
    {
      key: "law_name",
      label: "Полное наименование юр. лица",
      mask: "",
    },
    {
      key: "representative_basis",
      label: "В лице / основание полномочий (для шапки договора)",
      mask: "",
    },
    {
      key: "law_address",
      label: "Адрес регистрации",
      mask: "",
    },
    {
      key: "tax_id",
      label: taxIdLabel(jurisdiction, "entrepreneur"),
      mask: taxIdReactInputMask(jurisdiction),
    },
  ]

  if (hasOgrnField(jurisdiction)) {
    fields.push({
      key: "ogrn",
      label: "ОГРН",
      mask: "999999999999999",
    })
  }

  return fields
}

function allFieldsForUser(userSession: any) {
  const jurisdiction = normalizeJurisdictionCode(userSession?.jurisdiction)
  return [
    ...MAIN_FIELDS,
    ...ENTREPRENEUR_FIELDS(jurisdiction),
    ...CUSTOMER_FIELDS(jurisdiction),
    ...BANK_DETAIL_FIELDS,
  ]
}

function getBankDetailsObject(userSession: object, fields: Array<object>) {
  const result: any = {};

  fields.forEach(({key}: any) => {
    let value = _.get(userSession, key, null)
    if (key == 'additional_phone_number' && value) {
      result[key] = cleanPhoneNumber(value, true)
      return;
    }

    if (key === "passport.issued_at" && value) {
      result[key] = moment(value).format('DD.MM.YYYY')

      return;
    }

    if (key === "birth_date" && value) {
      result[key] = moment(value).format('DD.MM.YYYY')

      return;
    }

    result[key] = value
  })

  return result
}

let UpdateUserFields: any = function UpdateUserFields(props: any) {
  const userSession = props.$store.userSession;
  const skipReload: boolean = !!props.skipReload
  const onUpdated: ((user: any) => void) | undefined = props.onUpdated
  const forceOpen: boolean = !!props.forceOpen
  const onForceOpenConsumed: (() => void) | undefined = props.onForceOpenConsumed
  const [showPopForUpdatingUserFields, setShowPopForUpdatingUserFields] = useState<any>(false)

  useEffect(() => {
    if (forceOpen) {
      setShowPopForUpdatingUserFields(true)
      onForceOpenConsumed?.()
    }
  }, [forceOpen])

  const stampInputState = useState(_.get(userSession, ENTREPRENEUR_STAMP_KEY, ""));
  const [stampValue, setStampValue] = stampInputState;
  
  const signatureInputState = useState(_.get(userSession, "passport.signature", ""));
  const [signatureValue, setSignatureValue] = signatureInputState;
  
  const [verificationCode, setVerificationCode] = useState('')
  const [verificationCodePopup, setVerificationCodePopup] = useState(false)
  const [codeChannel, setCodeChannel] = useState('sms')

  const [userFields, setUpdateUserFields] = useState<any>(
    getBankDetailsObject(userSession, allFieldsForUser(userSession))
  )

  // обновление значений формы
  useEffect(
    () => {
      setUpdateUserFields(getBankDetailsObject(userSession, allFieldsForUser(userSession)))
      setStampValue(_.get(userSession, ENTREPRENEUR_STAMP_KEY, ""))
      setSignatureValue(_.get(userSession, "passport.signature", ""))
    },
    [showPopForUpdatingUserFields]
  )

  const jurisdiction = normalizeJurisdictionCode(userSession?.jurisdiction)
  const entrepreneurFields = ENTREPRENEUR_FIELDS(jurisdiction)
  const customerFields = CUSTOMER_FIELDS(jurisdiction)

  async function updateSelf() {
    let fields = {...userFields}

    for(let key in fields) {
      let value = fields[key]
      if (value != null && value.length > 0) {
        fields[key] = value.trim()
      }
    }

    let phoneNumber = cleanPhoneNumber(fields.phone_number)
    if (phoneNumber && phoneNumber.slice(0,1) != '+') {
      phoneNumber = '+' + phoneNumber
    }
    fields.phone_number = phoneNumber

    if (phoneNumber != userSession.phone_number && verificationCode.length == 0) {
      if (!(await sendVerificationCode(props, phoneNumber, 'sms', 'change_phone_number', {
        old_phone_number: userSession.phone_number,
        user_id: userSession._id
      })).usedChannel) {
        return
      }
      setVerificationCodePopup(true)
      return;
    }

    fields['verification_code'] = verificationCode

    let additionalPhone = cleanPhoneNumber(fields.additional_phone_number)
    if (additionalPhone && additionalPhone.slice(0,1) != '+') {
      additionalPhone = '+' + additionalPhone
    }
    fields.additional_phone_number = additionalPhone

    fields.tax_id = cleanDigitsField(fields.tax_id)

    fields.ogrn = cleanDigitsField(fields.ogrn)

    if (userSession.role != 'customer') {
      fields[ENTREPRENEUR_STAMP_KEY] = stampValue;
    }
    
    // Добавляем подпись в passport (используем точечную нотацию, как для других полей passport)
    fields["passport.signature"] = signatureValue;

    let issued_at = _.get(fields, "passport.issued_at", "")
    if (issued_at) {
      let issued_at_error = validate('ruPassportIssuedDidAt', issued_at, "Дата выдачи паспорта")
      if (issued_at_error) {
        notifyUser(props, "Ошибка в заполнении поля", issued_at_error)
        return
      } else {
        fields["passport.issued_at"] = moment(issued_at, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    }

    let birth_date = _.get(fields, "birth_date", "")
    if (birth_date) {
      let birth_date_error = validate('birthDate', birth_date, "Дата рождения")
      if (birth_date_error) {
        notifyUser(props, "Ошибка в заполнении поля", birth_date_error)
        return
      } else {
        fields["birth_date"] = moment(birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD')
      }
    }

    try {
      const response: any = await httpClient.patch("/user/self", fields)
      setShowPopForUpdatingUserFields(false)
      notifyUser(props, "Данные обновлены")

      if (skipReload) {
        // Оптимистично мержим отправленные поля в userSession, поддерживая
        // точечную нотацию (например "passport.signature").
        const nextUser: any = _.cloneDeep(userSession || {})
        Object.keys(fields).forEach((key) => {
          if (key === 'verification_code') return
          _.set(nextUser, key, fields[key])
        })
        // Если бэк вернул обновлённого юзера — накатываем сверху.
        const serverUser = response?.data?.user || response?.data || null
        if (serverUser && typeof serverUser === 'object') {
          Object.assign(nextUser, serverUser)
        }
        if (props.$commitToStore) {
          props.$commitToStore({userSession: nextUser})
        }
        if (onUpdated) {
          onUpdated(nextUser)
        }
      } else {
        setTimeout(() => {
          location.reload()
        }, 300)
      }
    } catch (error) {
      notifyAboutError(props, error)
    } finally {
      setVerificationCode('')
    }
  }

  function phoneNumberInput(key: string, label: string) {
    return (
      <PhoneNumberInput
        value={userFields[key] ?? ""}
        disabled={false}
        onChange={(value) => {
          setUpdateUserFields({ ...userFields, [key]: value })
        }}
        placeholder={label}
        id={key}
        className="ui-kit-v2"
      />
    )
  }

  function input(key: string, label: string, mask: string) {
    if (key === 'representative_basis') {
      return (
        <TextArea
          value={(userFields[key] ?? "").toString()}
          onChange={(e) => setUpdateUserFields({ ...userFields, [key]: e.target.value })}
          placeholder={label}
          minRows={1}
          maxRows={8}
        />
      )
    }

    return mask
        ? <InputMask
            mask={mask}
            placeholder={label}
            value={userFields[key]}
            disabled={false}
            onChange={({ target: { value } }: any) => setUpdateUserFields({ ...userFields, [key]: value })}
        >
          <TextField id={key}/>
        </InputMask>
        : <TextField
            id={key}
            placeholder={label}
            value={userFields[key] ?? ""}
            onChange={({ target: { value } }: any) => setUpdateUserFields({ ...userFields, [key]: value })}
            variant="outlined"
        />
  }

  function prepareElementsByFields(fields: Array<object>) {
    return fields.map(({key, label, mask}: any) => {
      return (
        <div
          key={key}
          className="update-user-fields-field-row"
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "6px"
          }}
        >
          <div
            className="update-user-fields-field-label"
            style={{
              width: "100%",
              textAlign: "left",
              lineHeight: "1.25",
              margin: 0
            }}
          >
            {label}
          </div>
          <div className="update-user-fields-field-input" style={{ width: "100%", maxWidth: "none" }}>
            {(key == "phone_number" || key == "additional_phone_number")
              ? phoneNumberInput(key, label)
              : input(key, label, mask)}
          </div>
        </div>
      )
    })
  }


  // Опционально рендерим попап через портал в document.body — полезно,
  // когда UpdateUserFields используется внутри другого попапа и нужно вырваться
  // из его DOM/стеклянного фона.
  const portalEnabled: boolean = !!props.portal
  const withOptionalPortal = (node: any) => {
    if (!node) return node
    if (portalEnabled && typeof document !== 'undefined') {
      return createPortal(node, document.body)
    }
    return node
  }

  const updatePopupNode = (
      showPopForUpdatingUserFields && !verificationCodePopup &&
          <Popup
              style={{zIndex: UI_LAYER_POPUP}}
              maxWidth="650px"
              onClose={() => setShowPopForUpdatingUserFields(false)}
          >
            <div
              className="update-user-fields-v2"
              style={{
                width: "100%",
                maxWidth: "650px",
                margin: "0 auto",
                boxSizing: "border-box",
                textAlign: "left"
              }}
            >

              <div className="update-user-fields-section-title">
                Основная информация:
              </div>
              {prepareElementsByFields(MAIN_FIELDS)}


              {
                  userSession.role == 'customer' &&
                  <>
                    <div className="update-user-fields-section-title">
                      Паспортные данные:
                    </div>
                    {
                      prepareElementsByFields(customerFields)
                    }
                  </>
              }

              {
                  userSession.role == 'entrepreneur' &&
                  <>
                    <div className="update-user-fields-section-title">
                      Данные юр. лица:
                    </div>
                    {
                      prepareElementsByFields(entrepreneurFields)
                    }
                  </>
              }

              <div className="update-user-fields-section-title">
                Реквизиты:
              </div>
              {
                prepareElementsByFields(BANK_DETAIL_FIELDS)
              }

              {
                  userSession.role != 'customer' &&
                  <>
                    <div className="update-user-fields-section-title">
                      Печать организации:
                    </div>
                    <UserStamp
                        style={{marginTop: "15px"}}
                        inputState={stampInputState}
                    />
                  </>
              }

              <div className="update-user-fields-section-title">
                Рукописная подпись:
              </div>
              <UserSignature
                  style={{marginTop: "15px"}}
                  inputState={signatureInputState}
              />

              <hr className="update-user-fields-divider"/>

              <button
                  className="update-user-fields-submit"
                  style={{width: "100%", display: "flex"}}
                  onClick={() => {
                    updateSelf()
                  }}
              >
                <span className="button-text">Обновить</span>
              </button>
            </div>
          </Popup>
  )

  const verificationPopupNode = (
      verificationCodePopup &&
          <Popup
              style={{zIndex: UI_LAYER_POPUP}}
              onClose={() => setVerificationCodePopup(false)}
          >
            <VerificationCodeView
                verification_code={verificationCode}
                code_channel={codeChannel}
                phone_number={userFields.phone_number}
                disabled_code_channels={userSession?.disabled_code_channels ?? []}
                updateVerificationCode={(value: string) => {
                  setVerificationCode(value)
                }}
                updateCodeChannel={(value: string) => {
                  setCodeChannel(value)
                }}
                finish={ async () => {
                  setVerificationCodePopup(false)
                  updateSelf()
                }}
                back={() => {
                  setVerificationCodePopup(false)
                }}
                purpose="change_phone_number"
                purpose_meta={{
                  old_phone_number: userSession.phone_number,
                  user_id: userSession._id
                }}
                $store={props.$store}
            />
          </Popup>
  )

  return (
    <>
      <button className="update-user-fields-edit-btn ui-kit-v2-button" style={{marginRight: "0px"}} onClick={() => setShowPopForUpdatingUserFields(true)}>
        <Edit />
      </button>
      {withOptionalPortal(updatePopupNode)}
      {withOptionalPortal(verificationPopupNode)}
    </>
  )
}

UpdateUserFields = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
      $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(UpdateUserFields)

export default UpdateUserFields
